import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shrink",
  "use": "icon-shrink-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shrink\"><path d=\"M0 12.792v-2.125h5.333V16H3.208v-3.208H0zm3.208-9.584V0h2.125v5.333H0V3.208h3.208zM10.667 16v-5.333H16v2.125h-3.208V16h-2.125zm2.125-12.792H16v2.125h-5.333V0h2.125v3.208z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol